import React from "react";
import "./style.css";

export default function WhyChooseUs() {
  const features = [
    {
      icon: "💡",
      title: "AI-First Architecture",
      description:
        "We integrate AI Agents and automation into business workflows from day one — not as an afterthought.",
      tag: "Innovation",
      accent: "indigo",
    },
    {
      icon: "🔐",
      title: "Security & Privacy Focused",
      description:
        "Data isolation, secure cloud hosting, and enterprise-grade access control built into every system we deliver.",
      tag: "Enterprise-Grade",
      accent: "green",
    },
    {
      icon: "🤝",
      title: "Dedicated Customer Support",
      description:
        "24/7 support via WhatsApp, email, and ticketing — a dedicated account manager who knows your product.",
      tag: "24 / 7 Support",
      accent: "blue",
    },
    {
      icon: "📈",
      title: "Long-Term Product Thinking",
      description:
        "We don't just build and hand over. We evolve, maintain, and grow your product alongside your business.",
      tag: "Growth Partner",
      accent: "amber",
    },
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <div className="section-wrapper">
          {/* Section Header */}
          <div className="wcu-header">
            <h2 className="wcu-title">Built Different. Designed to Scale.</h2>
            <p className="wcu-subtitle">
              Every decision we make is driven by long-term product thinking,
              not short-term delivery.
            </p>
          </div>

          {/* Feature Blocks Grid */}
          <div className="row gx-4 gy-4">
            {features.map((feature, index) => (
              <div key={index} className="col-lg-6 col-md-6 col-12">
                <div className={`wcu-block wcu-block--${feature.accent}`}>
                  {/* Icon */}
                  <div className="wcu-icon-container">
                    <span className="wcu-icon">{feature.icon}</span>
                  </div>

                  {/* Content */}
                  <div className="wcu-block-content">
                    <span className="wcu-tag">{feature.tag}</span>
                    <h4 className="wcu-block-title">{feature.title}</h4>
                    <p className="wcu-block-description">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
